export default __webpack_public_path__ + "static/media/customer-support.ce037c9b.png";